import { render, staticRenderFns } from "./MerchandisingRandomProduct.vue?vue&type=template&id=304087a6&scoped=true"
import script from "./MerchandisingRandomProduct.vue?vue&type=script&lang=js"
export * from "./MerchandisingRandomProduct.vue?vue&type=script&lang=js"
import style0 from "./MerchandisingRandomProduct.vue?vue&type=style&index=0&id=304087a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304087a6",
  null
  
)

export default component.exports